import { render } from "./LightboxGallery.vue?vue&type=template&id=4c0c695d&scoped=true"
import script from "./LightboxGallery.vue?vue&type=script&lang=js"
export * from "./LightboxGallery.vue?vue&type=script&lang=js"

import "./LightboxGallery.vue?vue&type=style&index=0&id=4c0c695d&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0c695d"]])

export default __exports__